const NotAllowed = () => (
  <h1>Access is not allowed! ⛔️</h1>
)

export default NotAllowed
